import { call, put, takeLatest } from "redux-saga/effects";
import {
  setCoupaFileUploadSuccess,
  setCoupaFileUploadFailure,
} from "../reducers/coupaFileUploadSlice";

import { uploadCoupaFile } from "../../service/drmCoupaFileUpload";

export function* workerUploadCoupaFile({ payload }) {
  try {
    const response = yield call(uploadCoupaFile, [
      payload.formData,
      payload.controller,
    ]);
    const data = response.data;
    yield put(setCoupaFileUploadSuccess(data?.message));
  } catch (error) {
    yield put(setCoupaFileUploadFailure(error.toString()));
  }
}
function* drmCoupaFileUploadSaga() {
  yield takeLatest(
    "coupaFileUpload/setCoupaFileUploadStart",
    workerUploadCoupaFile
  );
}

export default drmCoupaFileUploadSaga;
